export default "__VITE_ASSET__gjeH9aXA__"